import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IUploadUrlResult } from './';
import { InsectaServiceBase } from './insecta.base.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService extends InsectaServiceBase {
  public getUploadUrl(filename: string): Observable<IUploadUrlResult> {
    return this.get<IUploadUrlResult>(`/uploads/${filename}/url`, 'v1');
  }

  public uploadImage(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.postFormData<string>(`/uploads`, 'v1', formData);
  }
}
